import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import packageInfo from "../../../../package.json";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.css"],
})
export class AdminDashboardComponent implements OnInit {
  token: any;
  dashboardArray: any = {};
  webVersion: string = packageInfo.version;
  backendVersion: string = "";
  loading: boolean = false;
  fetch_page: any = 0;

  constructor(
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.dashboardGet();
    this.getProfile();
  }

  dashboardGet() {
    this.loading = true;
    this.services.dashboard(this.token).subscribe(
      (response: any) => {
        this.loading = false;
        this.dashboardArray = response.body.data;
        if (response.body.data && response.body.data.backend_version) {
          this.backendVersion = response.body.data.backend_version;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {});
  }

  GoToTruck() {
    this.router.navigateByUrl("admin/trucks");
  }
  GoToTrips() {
    this.router.navigateByUrl("admin/trips");
  }

  GoToUsers() {
    localStorage.setItem("fetch_page", this.fetch_page.toString());
    this.router.navigateByUrl("admin/users");
  }
  GoToTruckOwner() {
    this.router.navigateByUrl("admin/users");
    localStorage.setItem("truckOwner", "truckOwner");
  }
  GoToAdmin() {
    this.router.navigateByUrl("admin/users");
    localStorage.setItem("admin", "admin");
  }
  GoToDrivers() {
    this.router.navigateByUrl("admin/drivers");
  }
}
